module.exports = require("@wel-ui/component-heading");



//////////////////
// WEBPACK FOOTER
// ../node_modules/@wel-ui/components/Heading/index.js
// module id = 156
// module chunks = 0